// i18n-web.ts
// This i18n file created because I failed to conditionally initiate i18n configuration based on different platforms.
// To be specific, the problems occurs on native side.
//
// In Expo, we have to apply the language detector to i18n instance. But before that, we have to import
// expo-localization.
//
// While expo-localization is weird. If you import it, whatever you use it or not, the code runs. Apparently, we would
// not use the locale object from expo-localization in web. But putting this code in the Platform.OS !== web statement,
// it would run under web environment anyway. It crashes the web application.
//
// Don't try dynamic import provided by NextJS either. It's only for the component.
// Don't try original dynamic import. It's async. You have to enable top-level await option. I haven't tested this.

// @author xyd

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en-AU';
import zh from './zh-CN';
// import tw from './zh-TW';
import {
  DEFAULT_LANGUAGE,
  SUPPORTED_LANGUAGES,
  IsLanguageEnabledRoute,
} from '../constants/settings';
import { isWeb } from '../utilities/platform';

// Decides which language a given route should render in. Single source of truth for that policy -
// both the initial load and every client-side navigation go through it (see gatsby-browser.js).
//
// Order of precedence:
//   1. An explicit ?lang= querystring, used by functional deep links such as Patient Consent.
//   2. A previously-saved localStorage.LANG, but ONLY on the LANGUAGE_ENABLED_ROUTES.
//   3. DEFAULT_LANGUAGE.
//
// Step 2 is what keeps the marketing site English for previously-visited users: their saved
// language is still on disk, it just no longer applies outside the functional routes.
export const ResolveLanguage = (pathname?: string, search?: string) => {
  if (!isWeb) return DEFAULT_LANGUAGE;
  try {
    const queryLang = new URLSearchParams(search ?? window.location.search).get('lang');
    if (queryLang && SUPPORTED_LANGUAGES.includes(queryLang)) return queryLang;

    const path = pathname ?? window.location.pathname;
    if (IsLanguageEnabledRoute(path) && SUPPORTED_LANGUAGES.includes(localStorage.LANG)) {
      return localStorage.LANG;
    }
  } catch (e) {
    // ignore, fall back to default
  }
  return DEFAULT_LANGUAGE;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'en-AU': en,
      'zh-CN': zh,
      // 'zh-TW': tw,
    },
    // have a common namespace used around the full app
    // ns: ['translation'],
    // defaultNS: 'translation',
    // Always initialise to the default so the server-rendered HTML and the first client render
    // agree. ResolveLanguage is applied just after hydration instead, which avoids a mismatch on
    // routes where the saved language differs from what was built.
    lng: DEFAULT_LANGUAGE,
    fallbackLng: 'en-AU',
    debug: false,
    preload: !isWeb && ['en-AU', 'zh-CN'], // array of languages to preload. Important on serverside to assert translations are loaded before rendering views.
    // cache: {
    //   enabled: true,
    // },
    interpolation: {
      escapeValue: false, // not needed for react as it does escape per default to prevent xss!
    },
    initImmediate: false,
    // saveMissing: true,
    // missingKeyHandler: (lng, ns, key, fallbackValue) => {
    //   return key;
    // },
  });

export default i18n;
